import { useNavigate } from "react-router-dom";
import Info from "../../components/Info";
import useCurrentUserAccount from "../../hooks/data/queries/useCurrentUserAccount";
import { useEffect } from "react";

function CapitalRedirect(): JSX.Element {
  const { data: currentUserAccountData } = useCurrentUserAccount();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUserAccountData?.type === "Customer") {
      navigate(`/capital/${currentUserAccountData.accountHolderCode}`);
    }
  });

  return (
    <div className="px-16">
      <Info message="Please use Client Settings to access Capital."></Info>
    </div>
  );
}

export default CapitalRedirect;
